import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { ProductDto } from "../../../models/product/dto/product.dto";

export const GET_PRODUCT_QUERY_KEY = (id: string) => ['product', id];

export const useGetProduct = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_PRODUCT_QUERY_KEY(id),
        queryFn: () => client.fetchApi<ProductDto, {}>({ endpoint: `products/${id}`, method: 'GET' }),
        enabled: !!id,
    });
};
